export default "__VITE_ASSET__$qzywCW0__"